import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      text: "Al Jurf's team was incredibly professional. They worked fast, ensuring our home was spotless and pest-free. Their service was top-notch.",
      name: "Sarah Ahmed",
      designation: "Homeowner, Dubai",
      image: "/assets/image/user.jpg",
    },
    {
      id: 2,
      text: "We trusted Al Jurf to handle a pest issue in our office, and they did an amazing job. The team was efficient and the results were impressive.",
      name: "Mohammed Khalid",
      designation: "Operations Manager",
      image: "/assets/image/user.jpg",
    },
    {
      id: 3,
      text: "Al Jurf came to the rescue when we had an emergency pest problem. The service was fast, professional, and our space was clean and safe again.",
      name: "Jessica Lewis",
      designation: "Hotel Supervisor",
      image: "/assets/image/user.jpg",
    },
    {
      id: 4,
      text: "We use Al Jurf for cleaning and pest control at our office. They always deliver excellent results with great attention to detail every time.",
      name: "Omar Bin Zayed",
      designation: "HR Director",
      image: "/assets/image/user.jpg",
    },
    {
      id: 5,
      text: "Al Jurf has helped us maintain clean and safe spaces at our properties. Their pest control service is reliable, and their cleaning is always thorough.",
      name: "Linda Parker",
      designation: "Real Estate Consultant",
      image: "/assets/image/user.jpg",
    },
    {
      id: 6,
      text: "Al Jurf took care of a pest issue in our restaurant quickly and effectively. Their team was professional, and we felt secure after their service.",
      name: "Rashid Al Mansoori",
      designation: "Restaurant Owner",
      image: "/assets/image/user.jpg",
    },
  ];

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section
      className="testi-area-3 bg-smoke overflow-hidden space-top"
      data-pos-for=".blog-area-3"
      data-sec-pos="bottom-half"
    >
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots"></span>
            </span>
            TESTIMONIALS
            <span className="shape right">
              <span className="dots"></span>
            </span>
          </span>
          <h2 className="sec-title">Our Client's Review</h2>
        </div>
      </div>

      <div className="container">
        <Slider
          {...settings}
          className="slider-shadow th-carousel arrow-style6 testi-slider3"
        >
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="col-lg-6 hh">
              <div className="testi-card style3">
                <div className="testi-card-icon">
                  <img src="/assets/img/icon/testi-quote3.svg" alt="img" />
                </div>
                <p className="testi-card_text">
                  <span className="text-theme">“</span>
                  {testimonial.text}
                  <span className="text-theme">”</span>
                </p>
                <div className="testi-card_content">
                  <div className="testi-card_img">
                    <img
                      src={testimonial.image}
                      alt="Avatar"
                      height={80}
                      width={80}
                    />
                  </div>
                  <div className="testi-card_bottom">
                    <h3 className="testi-card_name">{testimonial.name}</h3>
                    <span className="testi-card_desig">
                      {testimonial.designation}
                    </span>
                    <div className="testi-card_review">
                      <i className="fa-regular fa-star-sharp"></i>
                      <i className="fa-regular fa-star-sharp"></i>
                      <i className="fa-regular fa-star-sharp"></i>
                      <i className="fa-regular fa-star-sharp"></i>
                      <i className="fa-regular fa-star-sharp"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialSection;
